import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';
import SalesDocumentsStatus from 'Config/authenticated/SalesDocumentsStatus';

export default class SalesDocumentAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'document';
    }

    constructor(data = []) {
        super(data);
        this.key = SalesDocumentAdapter._key;
        this.secondariesKeys = ['purchase'];
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Document'),
            icon: 'obj-slsy-document',
            count: 0,
            items: [],
            groupBy: [
                {
                    key: 'purchase',
                    label: Loc.g('Achat'),
                },
                {
                    key: 'document',
                    label: Loc.g('Vente'),
                },
                {
                    key: 'redactor',
                    label: Loc.g('Redactor'),
                },
            ],
        };
    }

    extractDataByType() {
        let data = [];

        if (this.data) {
            data = this.data.filter((item) => {
                return (
                    (item.object.type === this.key ||
                        this.secondariesKeys.includes(item.object.type)) &&
                    !item.is_archived
                );
            });
        }
        return data;
    }

    formatItem(item) {
        let link;
        switch (item.object.type) {
            case 'document':
                link = `/?_f=${item.object.sub_type}Overview&id=${item.object.id}`;
                break;
            case 'purchase':
                link = `/?_f=purchases_${item.object.sub_type}Overview&id=${item.object.id}`;
                break;
        }

        return {
            id: item.object.id,
            name: item.name,
            number: item.number,
            object: item.object,
            type: item.object.type,
            sub_type: item.object.sub_type,
            related: {
                name: item.related.name,
                type: item.related.type,
                last_name: item.related.last_name,
                first_name: item.related.first_name,
            },
            status: {
                color: SalesDocumentsStatus[item.object.sub_type][item.status].chipColor,
                label: SalesDocumentsStatus[item.object.sub_type][item.status].label,
            },
            amount: window.sellsyapp.$filters.numberFormatCurrencyCustomNumberFormat(item.amount, {
                currency: item.currency,
                currencysymbol: item.currency,
            }),
            link,
            component: 'search-result-sales-document',
        };
    }
}
